{
  "cancellation": {
    "confirmationTitle": "Cancelar la suscripción",
    "confirmationBodyOne": "¿Estás seguro de que quieres cancelar tu suscripción",
    "confirmationBodyTwo": "Una vez que caduque la suscripción, ya no tendrás acceso a tu cuenta ni a tus datos",
    "reasonHeadingOne": "Lamentamos que te vayas.",
    "reasonHeadingTwo": "Nos encantaría recibir su opinión sobre cómo mejorar Iventis.",
    "reasonSubheadingOne": "¿Cuál es el motivo principal de la cancelación?",
    "reasonSubheadingTwo": "Proporcione cualquier comentario adicional",
    "reasonOne": "No estoy utilizando Iventis por completo",
    "reasonTwo": "Me resulta difícil de usar",
    "reasonThree": "No tiene la función que estoy buscando",
    "reasonFour": "Es demasiado caro",
    "reasonFive": "He decidido cambiarme a otro producto",
    "reasonSix": "¿Otro",
    "addComment": "Añadir un comentario",
    "cancelSubscription": "Cancelar la suscripción",
    "reactivate": "Reactiva tu suscripción",
    "success": "Tu suscripción se ha cancelado y caducará el",
    "error": "Se ha producido un problema al cancelar la suscripción. Ponte en contacto con el servicio de asistencia.",
    "successReactivate": "Tu proyecto se ha reactivado",
    "errorReactivate": "Se ha producido un problema al reactivar tu suscripción. Ponte en contacto con el servicio de asistencia.",
    "contactUs": "Contacta con el soporte",
    "nonAutomatedCancel": "Ponte en contacto con el servicio de asistencia para cancelar tu suscripción",
    "nonAutomatedReactivate": "Ponte en contacto con el servicio de asistencia para reactivar tu suscripción",
    "cancelsOn": "Se cancela el",
    "keepSubscription": "Mantener la suscripción"
  },
  "limits": {
    "limitedResource": {
      "IndividualMap": "planes",
      "TeamMap": "planes",
      "User": "usuarios"
    },
    "out_of": "{{ current }} de los {{ maximum }} activos {{ resources }}",
    "users": {
      "limitReached": {
        "title": "Se ha alcanzado el límite de usuarios",
        "content": "Has alcanzado el número máximo de usuarios para este proyecto. Para agregar más usuarios, por favor"
      },
      "limitRemaining": {
        "title": "Queda 1 usuario",
        "content": "Estás a punto de alcanzar el número máximo de usuarios para este proyecto. Para agregar más usuarios"
      }
    },
    "custom_layer": {
      "title": "Actualiza para personalizar tu capa",
      "content": "Actualízate a nuestro plan profesional para una personalización ilimitada o ponte en contacto con nosotros en:"
    }
  }
}